import {Component, Injectable} from "@angular/core";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalBase} from "../../../services/modal/modal-base";

@Component({
    selector: 'uninstall-services-confirmation-modal',
    template: require('./uninstall-services-confirmation.modal.component.html'),
    styles: [ require('./uninstall-services-confirmation.modal.component.css') ]
})

export class UninstallServicesConfirmationModalComponent {
    terminalName: string;

    constructor(public activeModal: NgbActiveModal) {
    }
}

@Injectable()
export class UninstallServicesConfirmationModal extends ModalBase {
    constructor(modalService: NgbModal) {
        super(modalService, UninstallServicesConfirmationModalComponent)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/modals/uninstall-services-confirmation/uninstall-services-confirmation.modal.component.ts